import React, {useEffect, useState} from "react";
import SalaryPayslip from "../../../../../entities/DashboardPage/HRModule/SalaryManagementPage/ViewSalaryPayslip";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const Payslips = () => {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState();

  const {state} = useLocation();
  const {item}=state ||{};
  useEffect(() => {
    if(item?._id){

      getPayrollPayslip(item?._id);
      getPayslipSetting();
    }
  },[])
  
  const [pensiondata,setpensiondata] = useState([]);
  const [allowanceData,setallowanceData] = useState([]);
  const [levieData,setLevieData] = useState([]);
  const [fringeData,setFringeData] = useState([]);
  const [loanData,setLoanData] = useState([]);
  const [deductionData,setDeductionData] = useState([]);
  const [leaveData,setLeaveData] = useState([]);
  const [payslip, setPayslip] =useState([]);
  const [data,setData] = useState(item);
  const getPayrollPayslip =async (id,) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPayrollPayslip(id);
      // console.log(id,payrollId,"result data")

      if (result?.success) {
        setData(result?.data?.[0]);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const getPensionList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPensionList(item?.employee, item?.payroll);
      if (result?.success) {
        setpensiondata(result?.data?.pension);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getAllowanceList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getAllowanceList(item?.employee, item?.payroll);
      if (result?.success) {
        setallowanceData(result?.data?.allowance);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLevieList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLevieList(item?.employee,item?.payroll);
      if (result?.success) {
        setLevieData(result?.data?.levie);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getFringeList(item?.employee,item?.payroll);
      if (result?.success) {
        setFringeData(result?.data?.fringes);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLoanList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLoanPayslip(item?.employee, item?.payroll);
      if (result?.success) {
        setLoanData(result?.data?.loans);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getDeductionList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getDeductionPayslip(item?.employee, item?.payroll);
      if (result?.success) {
        setDeductionData(result?.data?.[0]?.deductions);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLeave =async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeavePayslip(id, data?.payroll?.createdAt, data?.payroll?.end);
      if (result?.success) {
        setLeaveData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleSalaryReport = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleSalaryReport(item?._id);

      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type:  "application/pdf"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  return (
    
    <SalaryPayslip getLeave={getLeave} leaveData={leaveData} getLoanList={getLoanList} getDeductionList={getDeductionList} deductionData={deductionData} loanData={loanData}  data={data} getPensionList={getPensionList} pensionData={pensiondata} getAllowanceList={getAllowanceList} allowanceData={allowanceData} getLevieList={getLevieList} levieData={levieData} 
      getFringeList={getFringeList} fringeData={fringeData} payslip={payslip} handleSalaryReport={handleSalaryReport}  loading={loading}/>
  )


}

export default Payslips;
